// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__UFLWJ","buttons":"RemoveExpirationActionButtons_buttons__1F4QD"};